import { HtmlParser } from './HtmlParser';

export class GenericParser extends HtmlParser {}
